import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Remove useParams since we'll parse the hash
import { loginThunk } from "../../redux/slices/authSlice";
import { toast } from "react-toastify";

const InitialLoginHandler = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, user } = useSelector((state) => state.auth);

  useEffect(() => {
    const handleInitialLogin = async () => {
      // Get the hash portion of the URL
      const hash = window.location.hash;

      if (hash) {
        // Parse username and authToken from hash
        const matches = hash
          .substring(1)
          .match(/\/([^/]+)\/authToken\/([^/]+)/);

        if (matches) {
          const [, username, authToken] = matches;

          try {
            await dispatch(loginThunk({ username, token: authToken })).unwrap();
            localStorage.setItem("knowledge_token", authToken);

            navigate("/");
            window.location.reload();
          } catch (error) {
            toast.error("Login failed");
            console.error("Login failed:", error);
          }
        } else {
          console.error("Invalid login URL format");
        }
      } else if (user) {
        toast.error("User is already logged in");
        navigate("/");
      }
    };

    handleInitialLogin();
  }, [dispatch, navigate, user]);

  // Loading and error states
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="text-lg font-semibold">Logging in...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center text-red-600">
          <div className="text-lg font-semibold">Error: {error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="text-lg font-semibold">Redirecting...</div>
      </div>
    </div>
  );
};

export default InitialLoginHandler;
